import React, { useEffect } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { PartyWise1, resetPartyWise } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export default function PartyWise({ selectedProduction, selectedAccount }) {

  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { PartyWisedata } = useSelector((state) => state.GreyDashboardSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  useEffect(() => {
    dispatch(resetPartyWise())
    dispatch(PartyWise1({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])


  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    PartyWisedata?.OpInwMeter?.[0]?.FAcYear
  );

  const tableData = (PartyWisedata?.OpInwMeter || []).map(
    (row, index, arr) => ({
      // srNumber: (index + 1),
      ItemName: row.ItemName,
      AcName: row.AcName,
      OpInwMeter: row.OpInwMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];

  const getYearFromRange = (range) => {
    if (!range) return "";

    const parts = range.split("-");

    if (parts.length === 2) {
      const startYear = parts[0].split("/").pop();
      const endYear = parts[1].split("/").pop().slice(-2);
      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const uniqueYears = [
    ...new Set(
      (PartyWisedata?.OpInwMeterMonth || []).map((el) =>
        getYearFromRange(el.AcYear)
      )
    ),
  ];

  const groupedData = {};

  (PartyWisedata?.OpInwMeterMonth || []).forEach((row) => {
    const group = row.AcName;
    const year = getYearFromRange(row.AcYear);

    if (!groupedData[group]) {
      groupedData[group] = {
        AcName: group,
        TotalOpInwMeter: 0,
      };
    }

    groupedData[group][year] = row.OpInwMeter;

    groupedData[group].TotalOpInwMeter += row.OpInwMeter || 0;
  });

  const tableData1 = Object.values(groupedData).map((item, index) => ({
    // srNumber: index + 1,
    ...item,
  }));

  const columns1 = [
    { label: "Charts", key: "charts" },
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },

    {
      label: "Total Meter",
      key: "TotalOpInwMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },

    ...uniqueYears.map((year) => ({
      label: year,
      key: year,
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    })),
  ];

  const isNoData =
    !PartyWisedata?.OpInwMeter ||
    PartyWisedata?.OpInwMeter.length === 0;

  if (PartyWisedata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }

  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row
        className="justify-content-center"
        style={{ margin: 0, padding: 0 }}
      >

        <Col md={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18Px",
                  margin: 0,
                  letterSpacing: "1px",
                   fontWeight: "700"
                }}
              >
                PARTYWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>
        <Col md={12} className="pt-4" style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18Px",
                  margin: 0,
                  letterSpacing: "1px",
                   fontWeight: "700"
                }}
              >
                YEARWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}